export const dataProcessingAgreement = [

  {
    id: 1,
    title: "1. Introduction and Purpose",

    content: `
This Data Processing Agreement ("DPA") describes how Magyne ERP
processes personal information on behalf of customers using Magyne
software solutions.

This agreement forms part of the relationship between Magyne and
organizations that use our services.

The purpose of this agreement is to ensure that customer information
is processed securely, transparently and in accordance with applicable
data protection requirements.
`
  },


  {
    id: 2,
    title: "2. Definitions",

    content: `
For the purposes of this agreement:

Data Controller:
The customer organization that determines why and how personal data
is processed.

Data Processor:
Magyne ERP, which processes personal data on behalf of the
customer.

Personal Data:
Any information relating to an identifiable individual.

Data Subject:
The individual whose personal information is processed.

Processing:
Any activity performed on personal data including collection,
storage, retrieval, modification or deletion.
`
  },


  {
    id: 3,
    title: "3. Roles and Responsibilities",

    content: `
The customer acts as the Data Controller and remains responsible for:

• Determining the purpose of data processing.

• Ensuring lawful collection of personal information.

• Obtaining required consent where applicable.

• Managing user access within their organization.


Magyne acts as the Data Processor and is responsible for:

• Processing data only according to customer instructions.

• Protecting customer information.

• Maintaining appropriate security controls.

• Supporting customer compliance obligations.
`
  },


  {
    id: 4,
    title: "4. Scope of Processing",

    content: `
Magyne may process information required to provide software services,
including but not limited to:

• User account information.

• Business information.

• Employee information.

• Student information.

• Customer records.

• Transaction information.

• System usage information.

The exact information processed depends on the Magyne solution
selected by the customer.
`
  },


  {
    id: 5,
    title: "5. Data Processing Instructions",

    content: `
Magyne processes customer information only for purposes related to:

• Providing requested software services.

• Maintaining platform security.

• Supporting users.

• Improving system reliability.

• Performing technical operations required to deliver services.

Magyne will not use customer data for unrelated purposes without
authorization.
`
  },


  {
    id: 6,
    title: "6. Security Measures",

    content: `
Magyne implements technical and organizational security measures
designed to protect customer information.

These measures include:

• Secure authentication mechanisms.

• Role-based access control.

• Tenant data isolation.

• Encryption of sensitive information.

• Secure API communication.

• Access monitoring.

• Backup and recovery procedures.

Security measures are continuously reviewed and improved.
`
  },


  {
    id: 7,
    title: "7. Tenant Data Isolation",

    content: `
Magyne operates a multi-tenant SaaS architecture.

Customer environments are logically separated to prevent unauthorized
access between organizations.

Magyne applies controls including:

• User and tenant verification.

• Authorized database access.

• Protected connection management.

• Access validation before retrieving information.

Each customer can only access data belonging to their authorized
organization.
`
  },


  {
    id: 8,
    title: "8. Confidentiality",

    content: `
Magyne maintains confidentiality of customer information.

Access to customer data is restricted to authorized personnel who
require access to perform legitimate business and technical duties.

Magyne personnel are required to maintain confidentiality obligations.
`
  },


  {
    id: 9,
    title: "9. Subprocessors and Third Parties",

    content: `
Magyne may use trusted third-party service providers to support
service delivery.

Examples may include:

• Cloud hosting providers.

• Email delivery providers.

• Payment providers.

• Monitoring services.

Magyne ensures that third-party providers maintain appropriate
security and confidentiality obligations.
`
  },


  {
    id: 10,
    title: "10. Data Subject Rights",

    content: `
Customers remain responsible for responding to requests from their
data subjects.

Where technically possible, Magyne provides tools and assistance
to help customers:

• Access personal information.

• Correct inaccurate information.

• Export information.

• Remove information where appropriate.
`
  },


  {
    id: 11,
    title: "11. Data Breach Notification",

    content: `
In the event of a security incident affecting customer information,
Magyne will:

• Investigate the incident.

• Take reasonable steps to contain the issue.

• Apply corrective actions.

• Notify affected customers where required.

Customers are responsible for notifying relevant authorities or
data subjects where required by applicable law.
`
  },


  {
    id: 12,
    title: "12. Data Retention and Deletion",

    content: `
Magyne retains customer information only for as long as necessary
to provide services or meet legal obligations.

Upon termination of services:

• Customer data may be returned where applicable.

• Customer data may be securely deleted according to agreed terms.

• Backup copies may be removed according to backup retention policies.
`
  },


  {
    id: 13,
    title: "13. International Data Transfers",

    content: `
Where customer information is processed across different regions,
Magyne takes reasonable measures to ensure appropriate protection
of information.

International processing may depend on:

• Cloud infrastructure location.

• Third-party service providers.

• Applicable legal requirements.
`
  },


  {
    id: 14,
    title: "14. Customer Responsibilities",

    content: `
Customers are responsible for:

• Ensuring lawful collection of personal information.

• Providing appropriate privacy notices.

• Managing user permissions.

• Protecting account credentials.

• Ensuring authorized use of Magyne services.
`
  },


  {
    id: 15,
    title: "15. Compliance and Audits",

    content: `
Magyne maintains policies and procedures designed to support
security and privacy compliance.

Customers may request reasonable information regarding Magyne's
security practices subject to confidentiality obligations.
`
  },


  {
    id: 16,
    title: "16. Agreement Updates",

    content: `
Magyne may update this Data Processing Agreement to reflect changes
in technology, security practices or applicable regulations.

Updated versions will be communicated through official channels.
`
  },


  {
    id: 17,
    title: "17. Contact Information",

    content: `
For questions regarding this Data Processing Agreement or data
protection matters, customers may contact Magyne ERP
through official support channels.
`
  }

];
